module.exports = __webpack_public_path__ + "img/bg81.215deb25.png";